export enum PrePostingServiceCode {
  SEDEX = '03220'
}
